<template>
  <b-row>
    <b-col>
      <h1 class="page-headline"><slot></slot></h1>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'PageHeadline',
};
</script>

<style scoped>
  .page-headline {
    margin-bottom: 20px;
  }
</style>
